// Bouwt een /signup-deeplink op basis van module-keuze, optionele partner-slug
// en optionele netwerk-CompagnyID. Wordt door NewProjectModal gebruikt zodat
// een portfolio-admin een sub-project-deeplink kan delen i.p.v. direct het
// project aan te maken.
//
// Spec: docs/features/onboarding-flow.md "Netwerk- en partner-context".
//
// Input:
//   {
//     origin: 'https://app.deccos.nl' | 'http://localhost:3000' | ...
//     modules: { impactMeten?, personas?, housevisits?, portfolio? }
//     partnerSlug: 'tosss' | 'fixtool' | null
//     networkCompagnyID: '<CompagnyID>' | null
//     baseEnabled: boolean | undefined  // explicit override; default = afgeleid van modules.impactMeten
//   }
//
// Output: volledige URL string, bv.
//   'https://app.deccos.nl/signup?modules=impactMeten,personas&base=true&partner=tosss'

const buildSignupDeeplink = ({
    origin = '',
    modules = {},
    partnerSlug = null,
    networkCompagnyID = null,
    baseEnabled = undefined,
} = {}) => {

    const moduleSlugs = ['impactMeten', 'personas', 'housevisits', 'portfolio']
        .filter((slug) => modules[slug] === true)

    const params = new URLSearchParams()

    if (moduleSlugs.length > 0) {
        params.set('modules', moduleSlugs.join(','))
    }

    // baseEnabled: default = afgeleid van modules.impactMeten. parseDeeplink
    // defaultet zelf op true, dus we emitten alleen `base=false`. Voor lege
    // module-keuze geen base-param emitten — laat de default-state staan.
    const hasAnyModule = moduleSlugs.length > 0
    const effectiveBase = baseEnabled !== undefined
        ? baseEnabled
        : !!modules.impactMeten

    if (hasAnyModule && effectiveBase === false) {
        params.set('base', 'false')
    } else if (baseEnabled === false) {
        // Expliciete override: emit base=false ook bij lege modules
        params.set('base', 'false')
    }

    if (partnerSlug) {
        params.set('partner', partnerSlug)
    }

    if (networkCompagnyID) {
        params.set('network', networkCompagnyID)
    }

    const query = params.toString()
    const base = origin.replace(/\/$/, '')   // trailing slash off

    return query
        ? `${base}/signup?${query}`
        : `${base}/signup`

}

export default buildSignupDeeplink
